import React from 'react';
import { CompanyRegistration, CompanyRegistrationErrors } from '../../../types';
import { provinces } from '../../../utils/data';

interface CompanyInfoSectionProps {
  formData: Partial<CompanyRegistration>;
  errors: CompanyRegistrationErrors;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const CompanyInfoSection: React.FC<CompanyInfoSectionProps> = ({
  formData,
  errors,
  onInputChange
}) => {
  return (
    <>
      <h3 className="uk-heading-small uk-margin-small-top">Información de la Empresa</h3>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="razon-social">Razón Social *</label>
        <div className="uk-form-controls">
          <input 
            className={`uk-input ${errors.razonSocial ? 'uk-form-danger' : ''}`}
            id="razon-social" 
            name="razonSocial"
            type="text" 
            placeholder="Razón social de la empresa" 
            value={formData.razonSocial || ''}
            onChange={onInputChange}
            required 
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.razonSocial && (
            <div className="uk-text-danger uk-text-small">{errors.razonSocial}</div>
          )}
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="nombre-fantasia">Nombre de Fantasía *</label>
        <div className="uk-form-controls">
          <input 
            className={`uk-input ${errors.nombreFantasia ? 'uk-form-danger' : ''}`}
            id="nombre-fantasia" 
            name="nombreFantasia"
            type="text" 
            placeholder="Nombre comercial de la empresa" 
            value={formData.nombreFantasia || ''}
            onChange={onInputChange}
            required 
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.nombreFantasia && (
            <div className="uk-text-danger uk-text-small">{errors.nombreFantasia}</div>
          )}
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="direccion">Dirección *</label>
        <div className="uk-form-controls">
          <input 
            className={`uk-input ${errors.direccion ? 'uk-form-danger' : ''}`}
            id="direccion" 
            name="direccion"
            type="text" 
            placeholder="Calle, número, ciudad" 
            value={formData.direccion || ''}
            onChange={onInputChange}
            required 
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.direccion && (
            <div className="uk-text-danger uk-text-small">{errors.direccion}</div>
          )}
        </div>
      </div>
      
      <div className="uk-grid uk-grid-small" data-uk-grid>
        <div className="uk-width-1-3@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="pais">País</label>
            <div className="uk-form-controls">
              <select 
                className="uk-select" 
                id="pais" 
                name="pais"
                value={formData.pais || 'Argentina'}
                onChange={onInputChange}
                style={{ color: '#333', backgroundColor: '#fff', textTransform: 'none' }}
              >
                <option value="Argentina">Argentina</option>
                <option value="Brasil">Brasil</option>
                <option value="Chile">Chile</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Perú">Perú</option>
                <option value="Colombia">Colombia</option>
                <option value="Ecuador">Ecuador</option>
                <option value="Venezuela">Venezuela</option>
              </select>
            </div>
          </div>
        </div>
        
        <div className="uk-width-2-3@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="provincia">Provincia *</label>
            <div className="uk-form-controls">
              <select 
                className={`uk-select ${errors.provincia ? 'uk-form-danger' : ''}`}
                id="provincia" 
                name="provincia"
                value={formData.provincia || ''}
                onChange={onInputChange}
                required
                style={{ color: '#333', backgroundColor: '#fff', textTransform: 'none' }}
              >
                <option value="">Seleccionar...</option>
                {provinces.map(province => (
                  <option key={province} value={province}>{province}</option>
                ))}
              </select>
              {errors.provincia && (
                <div className="uk-text-danger uk-text-small">{errors.provincia}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className="uk-grid uk-grid-small" data-uk-grid>
        <div className="uk-width-2-3@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="localidad">Localidad *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.localidad ? 'uk-form-danger' : ''}`}
                id="localidad" 
                name="localidad"
                type="text" 
                placeholder="Ciudad o localidad" 
                value={formData.localidad || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.localidad && (
                <div className="uk-text-danger uk-text-small">{errors.localidad}</div>
              )}
            </div>
          </div>
        </div>
        
        <div className="uk-width-1-3@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="codigo-postal">Código Postal *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.codigoPostal ? 'uk-form-danger' : ''}`}
                id="codigo-postal" 
                name="codigoPostal"
                type="text" 
                placeholder="Código postal" 
                value={formData.codigoPostal || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.codigoPostal && (
                <div className="uk-text-danger uk-text-small">{errors.codigoPostal}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyInfoSection;
